import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Payment } from 'app/shared/models/class/payment/payment';

@Component({
  selector: 'app-payments-table',
  templateUrl: './payments-table.component.html',
  styleUrls: ['./payments-table.component.scss']
})
export class PaymentsTableComponent implements OnInit, OnChanges {

  @Input() data: Payment[];
  @Input() keyword: string;

  displayedColumns: string[] = ['bookingReference', 'paymentDate', 'paymentType', 'amount'];
  dataSource = new MatTableDataSource<Payment>();

  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  length: number;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 25, 50];
  pageEvent: PageEvent;
  color: ThemePalette = 'primary';

  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.data) {
      this.initTable(changes.data.currentValue);
      if (this.keyword?.length) {
        this.applyFilter(this.keyword);
      }
    }

    if (changes.keyword) {
      this.applyFilter(changes.keyword.currentValue);
    }
  }

  private applyFilter(keyword: string): void {
    this.dataSource.filter = keyword?.trim().toLocaleLowerCase();
  }

  private initTable(data: Payment[]): void {
    this.dataSource = new MatTableDataSource<Payment>(data.reverse());
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.length = data?.length;
  }

}
